// Mobile e dashboard são o mesmo app, mas o login só existe em /mobile/login.
// Quem é mandado para o login leva junto, em `?next=`, a URL que tentou abrir,
// e volta para ela depois de entrar.

export const LOGIN_PATH = '/mobile/login';
const MOBILE_BASE = '/mobile';

// Páginas de autenticação nunca são destino: voltaria para o próprio login.
const AUTH_PATHS = [LOGIN_PATH, '/mobile/password-reset'];

const isAuthPath = (pathname) =>
  AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

/**
 * Valida o `next` vindo da URL: só caminhos do próprio site (sem host
 * externo, `//outro.com` ou `javascript:`), fora das páginas de login.
 * Devolve o caminho normalizado (path + query + hash) ou null.
 */
export function safeNext(raw) {
  if (!raw || !raw.startsWith('/')) return null;
  let url;
  try {
    url = new URL(raw, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin || isAuthPath(url.pathname)) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

const currentPath = () => {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
};

/** Query `?next=` para voltar a `next` (por padrão, a URL atual), ou '' se não couber. */
export function nextSearch(next = currentPath()) {
  const target = safeNext(next);
  return target ? `?next=${encodeURIComponent(target)}` : '';
}

/** URL completa do login, levando o destino. */
export const loginUrl = (next) => `${LOGIN_PATH}${nextSearch(next)}`;

/** Sai da página atual para o login (fora do router: sessão expirada, guardas). */
export function redirectToLogin(next) {
  window.location.href = loginUrl(next);
}

/**
 * Destino depois do login. Caminho do mobile volta como rota do router
 * (`{ route }`, sem o prefixo /mobile); qualquer outro, como o dashboard,
 * precisa de carga completa (`{ href }`), porque o App escolhe a superfície
 * pelo pathname ao carregar.
 */
export function resolveNext(raw) {
  const target = safeNext(raw);
  if (!target) return null;
  const { pathname, search, hash } = new URL(target, window.location.origin);
  if (pathname === MOBILE_BASE || pathname.startsWith(`${MOBILE_BASE}/`)) {
    return { route: `${pathname.slice(MOBILE_BASE.length) || '/'}${search}${hash}` };
  }
  return { href: target };
}
